import React from "react";
import { motion } from "framer-motion";
import HeroImage from "../sections/Pricing/HeroImage";
import PackageDetailsTable from "../sections/Pricing/PackageDetailsTable";
import FullLengthSlider from "../sections/AllServicesSlider/FullLengthSlider";
import HelpSupport from "../sections/CustomerSupport/HelpSupport";
import PricingFAQs from "../components/common/PricingFAQs/PricingFAQs";
import ComparisonSection from "../components/common/ComparisonSection/ComparisonSection";
import {
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS,
  PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS,
} from "../sections/Public/shared/publicLayoutSpec";

const Pricing = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  };

  return (
    <>
      <HeroImage />
      
      {/* <PackageDetailsTable /> */}
      
      <motion.div
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <motion.div variants={fadeInUp} transition={{ duration: 0.6, ease: "easeOut" }}>
          <ComparisonSection />
        </motion.div>
        
        <motion.div variants={fadeInUp} transition={{ duration: 0.6, ease: "easeOut" }}>
          <PricingFAQs />
        </motion.div>
      </motion.div>
      
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <HelpSupport />
      </motion.div>
      
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <FullLengthSlider
          className={PUBLIC_SECTION_GAP_CLASS}
          itemGapClassName={PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS}
          labelClassName={PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS}
        />
      </motion.div>
    </>
  );
};

export default Pricing;
